module.exports = __webpack_public_path__ + "files/05d62076c4ae0dc0d6e6ef5adf5a1c2d.svg";